import { render, staticRenderFns } from "./Un-Outbound.vue?vue&type=template&id=240fbf96&scoped=true"
import script from "./Un-Outbound.vue?vue&type=script&lang=js"
export * from "./Un-Outbound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240fbf96",
  null
  
)

export default component.exports